import React, { FC, useState } from 'react';

import { Box, Container, Grid, Tab, Tabs, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

import { NewProposalModal } from '../../../components/community/voting/NewProposalModal';
import { ProposalList } from '../../../components/community/voting/ProposalList';
import { UserProposalList } from '../../../components/community/voting/UserProposalList';

enum PageTabs {
  Proposals,
  RelatedToMe,
  Submissions,
}

function tabA11yProps(index: number) {
  return {
    id: `proposals-tab-${index}`,
    'aria-controls': `proposals-tabpanel-${index}`,
  };
}

export const VotingPage: FC = () => {
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);

  const [newProposalModalOpen, setNewProposalModalOpen] = useState<boolean>(false);

  return (
    <>
      <Helmet>
        <title>Vote | Pegaxy Themis</title>
      </Helmet>
      <NewProposalModal open={newProposalModalOpen} handleClose={() => setNewProposalModalOpen(false)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pb: 6,
          pt: 8,
        }}
      >
        <Container maxWidth={'lg'}>
          <Box sx={{ mb: 4 }}>
            <Grid container justifyContent="space-between" spacing={3} sx={{ px: 2 }}>
              <Grid item>
                <Typography variant="h4">Vote</Typography>
              </Grid>
            </Grid>
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Tabs
                    value={currentTabIndex}
                    onChange={(e, newValue: number) => setCurrentTabIndex(newValue)}
                    aria-label="Proposal Tabs"
                  >
                    <Tab label="All Proposals" {...tabA11yProps(PageTabs.Proposals)} />
                    <Tab label="My History" {...tabA11yProps(PageTabs.RelatedToMe)} />
                  </Tabs>
                </Grid>

                <Grid item lg={12} sm={12} xs={12}>
                  {currentTabIndex === PageTabs.Proposals && <ProposalList />}
                  {currentTabIndex === PageTabs.RelatedToMe && <UserProposalList />}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};
